<header class="site-header">
  <div class="container header-content">
    <div class="brand">
      <a routerLink="/"><img src="logo.png" alt="Logo AGBE" class="logo" /></a>
    </div>
    
    <!-- Bouton Hamburger (visible uniquement sur mobile) -->
    <button class="mobile-menu-toggle" (click)="toggleMobileMenu()" aria-label="Menu">
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
        @if (!isMobileMenuOpen) {
          <line x1="3" y1="12" x2="21" y2="12"></line>
          <line x1="3" y1="6" x2="21" y2="6"></line>
          <line x1="3" y1="18" x2="21" y2="18"></line>
        } @else {
          <line x1="18" y1="6" x2="6" y2="18"></line>
          <line x1="6" y1="6" x2="18" y2="18"></line>
        }
      </svg>
    </button>

    <!-- Navigation principale (qui devient un accordéon/menu vertical sur mobile) -->
    <nav class="main-nav" [class.mobile-open]="isMobileMenuOpen">
      <ul>
        <li><a routerLink="/" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}" (click)="closeMobileMenu()">{{'nav.home'|translate:'Accueil'}}</a></li>
        
        <li class="dropdown-container" [class.open]="activeDropdown === 'about'" (click)="toggleDropdown($event, 'about')">
          <a routerLink="/qui-sommes-nous" routerLinkActive="active">{{'nav.about'|translate:'Qui sommes-nous ?'}}</a>
          <div class="dropdown-menu">
            <!-- <a routerLink="/presentation" (click)="closeMobileMenu()">{{ 'pages.core.header.header.text016' | translate:'Présentation' }}</a> -->
            <!--a routerLink="/fonctionnement" (click)="closeMobileMenu()">{{ 'pages.core.home.fonctionnement.menuTitle' | translate:'Fonctionnement' }}</a-->
            <a routerLink="/qui-sommes-nous" fragment="histoire" (click)="openSection($event, 'histoire')">{{ 'nav.history' | translate }}</a>
            <a routerLink="/qui-sommes-nous" fragment="vision-valeurs" (click)="openSection($event, 'vision-valeurs')">{{ 'nav.visionValues' | translate }}</a>
            <a routerLink="/qui-sommes-nous" fragment="partenaires" (click)="openSection($event, 'partenaires')">{{ 'nav.partners' | translate }}</a>
          </div>
        </li>

        <li class="dropdown-container" [class.open]="activeDropdown === 'association'" (click)="toggleDropdown($event, 'association')">
          <a routerLink="/etudes-bibliques" routerLinkActive="active">{{ 'nav.associationLife' | translate }}</a>
          <div class="dropdown-menu">
            <a routerLink="/etudes-bibliques" (click)="closeMobileMenu()">Études bibliques</a>
            <a routerLink="/vie-association/priere-evangelisation" (click)="closeMobileMenu()">{{ 'nav.prayerEvangelism' | translate }}</a>
            <a routerLink="/fonctionnement" (click)="closeMobileMenu()">{{ 'pages.core.home.fonctionnement.menuTitle' | translate:(i18n.language() === 'en' ? 'How we work' : 'Fonctionnement') }}</a>
          </div>
        </li>

        <li class="dropdown-container" [class.open]="activeDropdown === 'commissions'" (click)="toggleDropdown($event, 'commissions')">
          <a routerLink="/commissions" routerLinkActive="active">{{ 'pages.core.header.header.text008' | translate }}</a>
          <!--div class="dropdown-menu">
            <a routerLink="/commissions" fragment="missions" (click)="closeMobileMenu()">{{ 'pages.core.header.header.text009' | translate }}</a>
            <a routerLink="/commissions" fragment="projets" (click)="closeMobileMenu()">{{ 'pages.core.header.header.text010' | translate }}</a>
          </div-->
        </li>

        <li class="dropdown-container" [class.open]="activeDropdown === 'ressources'" (click)="toggleDropdown($event, 'ressources')">
          <a routerLink="/ressources/articles" routerLinkActive="active">{{'nav.resources'|translate:'Ressources'}}</a>
          <div class="dropdown-menu">
            <a routerLink="/ressources/articles" (click)="closeMobileMenu()">{{ 'pages.core.header.header.text011' | translate }}</a>
            <a routerLink="/ressources/messages" (click)="closeMobileMenu()">{{ 'pages.core.header.header.text012' | translate }}</a>
            <a routerLink="/ressources/famille" (click)="closeMobileMenu()">{{ 'pages.core.header.header.text013' | translate }}</a>
            <a routerLink="/ressources/societe" (click)="closeMobileMenu()">{{ 'pages.core.header.header.text014' | translate }}</a>
            <a routerLink="/ressources/videos" (click)="closeMobileMenu()">{{ 'pages.core.header.header.text015' | translate }}</a>
          </div>
        </li>

        <li><a routerLink="/actualites" routerLinkActive="active" (click)="closeMobileMenu()">{{ 'nav.news' | translate:'Actualités' }}</a></li>

        <li class="dropdown-container" [class.open]="activeDropdown === 'adherer'" (click)="toggleDropdown($event, 'adherer')">
          <a routerLink="/adherer" routerLinkActive="active">{{'nav.join'|translate:'Adhérer'}}</a>
          <div class="dropdown-menu">
            <!--a routerLink="/presentation" (click)="closeMobileMenu()">{{ 'pages.core.header.header.text016' | translate }}</a-->
            <a routerLink="/adherer" fragment="parcours" (click)="closeMobileMenu()">{{ 'pages.core.header.header.text017' | translate }}</a>
            <a routerLink="/adherer" fragment="formulaire" (click)="closeMobileMenu()">{{ 'pages.core.header.header.text018' | translate }}</a>
          </div>
        </li>

        <li><a routerLink="/contact" routerLinkActive="active" (click)="closeMobileMenu()">{{'nav.contact'|translate:'Contact'}}</a></li>
      </ul>
      
      <div class="nav-actions">
        <a routerLink="/faire-un-don" class="btn-action btn-donate" (click)="closeMobileMenu()">{{'nav.donate'|translate:'Donner'}}</a>

        <div class="custom-lang-selector" (click)="toggleLangMenu($event)">
          <div class="selected-lang">
            <img [src]="'https://flagcdn.com/w20/' + currentLang.flag + '.png'" [alt]="currentLang.code" class="flag-icon">
            <span class="lang-code">{{ currentLang.code }}</span>
          </div>
          @if (isLangMenuOpen) {
            <div class="lang-dropdown-menu">
              @for (lang of languages; track lang.code) {
                <div class="lang-option" (click)="selectLang(lang)">
                  <img [src]="'https://flagcdn.com/w40/' + lang.flag + '.png'" [alt]="lang.code" class="flag-icon-large">
                  <span>{{ lang.code }}</span>
                </div>
              }
            </div>
          }
        </div>

        @if (auth.isAuthenticated()) {
          <div class="account-menu">
            <button type="button" class="btn-action btn-login account-trigger" (click)="logout()">
              {{ 'nav.logout' | translate:'Déconnexion' }}
            </button>
            <div class="account-dropdown">
              <a routerLink="/administration" (click)="closeMobileMenu()">Dashboard</a>
            </div>
          </div>
        } @else {
          <a routerLink="/connexion" class="btn-action btn-login" (click)="closeMobileMenu()">
            {{ 'nav.login' | translate:'Connexion' }}
          </a>
        }
      </div>
    </nav>
  </div>
</header>
